export default "__VITE_ASSET__ab6f9d24__"